import { Form, Input } from "antd";
import tw from "twin.macro";

export const FormItem = tw(Form.Item)`mb-4 md:mb-6`;
export const InputField = tw(Input)`rounded-lg py-3 px-4 text-bc-neutral1`;
